var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-denied"},[_c('div',{staticClass:"icon"},[_c('feather',{attrs:{"type":"lock"}})],1),_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }